import React, {createContext, useState, useCallback} from "react";
import masterApi from "../../../services/masterApi";

export const RoleContext = createContext();

export const RoleContextProvider = ({children}) => {
    const [roleFunctionalities, setRoleFunctionalities] = useState([]);
    const [expandedData, setExpandedData] = useState([]);

    const validatePermissions = () => {
        const combinedArray = [...roleFunctionalities, ...expandedData];
        return combinedArray.some(item =>
          item.view || item.create || item.edit || item.delete
        );
      };

    const saveRolls = useCallback(async (roleId, roleFunctionalities, expandedData) => {    
        const combinedArray = [...roleFunctionalities, ...expandedData];    
        const requestData = {
        roleId,
        roleFunctionalities: combinedArray
        };
        // debugger;
        const response = await masterApi.createOrUpdateRoleMappings(requestData);
        console.log("createOrUpdateRoleMappings",response);
        // debugger;
        if(response?.response?.ok){
        alert("Role Saved Successfully");
        }
    }, []);

  return (
    <RoleContext.Provider value={{ roleFunctionalities, setRoleFunctionalities, expandedData, 
                                   setExpandedData, validatePermissions, saveRolls }}>
      {children}
    </RoleContext.Provider>
  );
};
